import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { RoutesPath } from "@ui/navigation/routes";
import React from "react";

export const PrivacyNoticeLink = (): JSX.Element => {
	const { format } = useI18n();
	return (
		<PrivacyNoticeText>
			{format("global.register.privacy_notice.description", {
				link: {
					className: "text-primary",
					onClick: event => {
						event.preventDefault();
						window.open(RoutesPath.RegisterPrivacyNotice, "_blank");
					},
				},
			})}
		</PrivacyNoticeText>
	);
};

const PrivacyNoticeText = styled.div`
	font-size: 12px;
`;
